import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useClassSubject(data = {}) {
  const { enabled = false, queryParams = '' } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getSubjects() {
    return privateFetch.get(`/v1/admin/subject${queryParams}`).then((res) => res.data);
  }

  return useQuery(['ES-class-subject', { data }], getSubjects, { enabled });
}

export default useClassSubject;
